import React from 'react';
import styles from './index.module.scss';

interface ProgressBarProps {
  splitCount: number; // 分闰数量
  mergeCount: number; // 合闰数量
  offlineCount?: number; // 离线数量
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ splitCount, mergeCount, offlineCount = 0 }) => {
  const total = splitCount + mergeCount + offlineCount;
  const splitPercent = total === 0 ? 0 : (splitCount / total) * 100;
  const mergePercent = total === 0 ? 0 : (mergeCount / total) * 100;
  const offlinePercent = total === 0 ? 0 : (offlineCount / total) * 100;

  return (
    <div className={styles.wrapper}>
      <div
        className={styles.wrapper_content}
        style={{
          display: 'flex',
          gap: 2,
        }}
      >
        {mergePercent > 0 && (
          <div
            style={{
              flexBasis: `${mergePercent}%`,
              background: '#16DD8E',
              transition: 'flex-basis 0.3s',
            }}
          />
        )}

        {splitPercent > 0 && (
          <div
            style={{
              flexBasis: `${splitPercent}%`,
              background: '#B3B3B3',
              transition: 'flex-basis 0.3s',
            }}
          />
        )}

        {offlinePercent > 0 && (
          <div
            style={{
              flexBasis: `${offlinePercent}%`,
              background: '#FF9247',
              transition: 'flex-basis 0.3s',
            }}
          />
        )}
      </div>

      <div className={styles.line_two}>
        <div className={styles.line_two_wrapper}>
          <span className={styles.icon} style={{ background: '#16DD8E' }} />
          <span className={styles.label}>开启：</span>
          <span className={styles.value}>{mergeCount}</span>
        </div>
        <div className={styles.line_two_wrapper}>
          <span className={styles.icon} style={{ background: '#B3B3B3' }} />
          <span className={styles.label}>关闭：</span>
          <span className={styles.value}>{splitCount}</span>
        </div>
        <div className={styles.line_two_wrapper}>
          <span className={styles.icon} style={{ background: '#FF9247' }} />
          <span className={styles.label}>离线：</span>
          <span className={styles.value}>{offlineCount}</span>
        </div>
      </div>
    </div>
  );
};
